<script>
export default {
  name: 'ModalIPhoneAppInstruction'
}
</script>

<template>
  <div :class="$style.modal">
    <p :class="$style.title">
      {{ $t("iPhoneAppInstall") }}
    </p>
    <p :class="$style.point">
      <span :class="$style.point__number">1.</span> {{ $t("iPhoneInstruction1") }}
    </p>
    <p :class="$style.point">
      <span :class="$style.point__number">2.</span> {{ $t("iPhoneInstruction2") }}
    </p>
    <p :class="$style.point">
      <span :class="$style.point__number">3.</span> {{ $t("iPhoneInstruction3") }}
      <img :class="$style.point__img" :src="require(`~/assets/img/icons/iphoneinst1.png`)" alt="button" />
    </p>
    <p :class="$style.point">
      <span :class="$style.point__number">4.</span> {{ $t("iPhoneInstruction4") }}
    </p>
    <p :class="$style.point">
      <span :class="$style.point__number">5.</span> {{ $t("iPhoneInstruction5") }}
    </p>
    <p :class="$style.point">
      <span :class="$style.point__number">6.</span> {{ $t("iPhoneInstruction6") }}
    </p>
  </div>
</template>

<style lang="scss">
.modal.modal--modaliphoneappinstruction {
  min-width: 320px;
  max-width: 508px !important;
  padding: 0 !important;
}
</style>

<style lang="scss" module>
.modal {
  padding: 12px;
  color: $white;
}

.title {
  font-size: 30px;
  line-height: 32px;
  font-weight: 700;
  margin: 10px 0 32px;
  padding-right: 40px;
}

.point {
  margin: 8px 0;
  color: $blue-grey05;

  &__number {
    font-weight: 700;
    color: $amber70;
  }
}
</style>
